export default __webpack_public_path__ + "static/hey_you-ac0d531e08e2f0fcfa0a54637b5833bb.png";